// Libraries
var React = require('react');

// Style
require('./DotMailerForm.scss');

class DotMailerModule extends React.Component {
	createContent = _ => {
		return {__html: this.props.data.content};
	};

	render() {
		return (
			<div className="DotMailerModule" id={this.props.data.id}>
				<script language="javascript" dangerouslySetInnerHTML={{__html: 'function validate_signup(frm) { var emailAddress = frm.Email.value; var errorString = "";if (emailAddress == "" || emailAddress.indexOf("@") == -1) {                                 errorString = "Please enter your email address";                 }                     var isError = false;     if (errorString.length > 0)         isError = true;     if (isError)         alert(errorString);                 return !isError; } function checkNumber(event) {     if ( (event.keyCode >= 48 && event.keyCode <= 57)  ||          (event.keyCode >= 96 && event.keyCode <= 105) ||          event.keyCode == 190 ||          event.keyCode == 110 ||          event.keyCode == 8   ||          event.keyCode == 9   ||          event.keyCode == 12   ||          event.keyCode == 27   ||          event.keyCode == 37   ||          event.keyCode == 39   ||          event.keyCode == 46         )       {         return true;       }       return false; }'}}></script>
				<script src='https://official.tottenhamhotspur.com/inc/cal.js'></script>
				<div dangerouslySetInnerHTML={this.createContent()}></div>
				<script language="javascript" dangerouslySetInnerHTML={{__html: 'var urlInput = document.getElementById("ci_consenturl");if (urlInput != null && urlInput != "undefined") {urlInput.value = encodeURI(window.location.href);}'}}></script>
			</div>
		);
	}
};

module.exports = DotMailerModule;



// WEBPACK FOOTER //
// ./src/components/DotMailerForm/DotMailerFormModule.js